import http from '@/shared/api/http'

export async function login({ email, password, rememberMe }) {
  return http.post('/auth/login', { email, password, rememberMe })
}

export async function register(payload) {
  return http.post('/auth/register', payload)
}

export async function resendConfirmation(email) {
  return http.post('/auth/resend-confirmation', { email })
}

export async function logoutRequest() {
  return http.post('/auth/logout')
}

export const startPasswordRecovery = email => http.post('/auth/password-recovery/start', { email })
export const verifyPasswordRecovery = (email, code) => http.post('/auth/password-recovery/verify', { email, code })
export const resetRecoveredPassword = payload => http.post('/auth/password-recovery/reset', payload)
